/** @module wgfractals/util/workgroup */
import { getDevice } from "../init.mjs";

// Fractal shaders always dispatch 2D (one thread per pixel): `rows` maps to
// canvas height (y), `cols` maps to canvas width (x).

const WORKGROUP_SIZE_2D = 8; // matches every fractal shader's @workgroup_size(8, 8)

/**
 * Calculates the number of 8×8 workgroups needed to cover a width×height pixel
 * grid, clamped to the device's `maxComputeWorkgroupsPerDimension` limit.
 * @param {number} rows - canvas height in pixels
 * @param {number} cols - canvas width in pixels
 * @returns {{ x: number, y: number }} for `dispatchWorkgroups(x, y)`
 */
export function calcWorkgroups(rows, cols) {
  const max = getDevice().limits.maxComputeWorkgroupsPerDimension;
  return {
    x: Math.min(Math.ceil(cols / WORKGROUP_SIZE_2D), max),
    y: Math.min(Math.ceil(rows / WORKGROUP_SIZE_2D), max),
  };
}
